'use client';

import { c as _c } from "react/compiler-runtime";
import { trackEvent } from '@svenskaspelab/nova-core/nextjs/analytics';
import { OpenModalButton } from '@svenskaspelab/poolbetting/ui/Modal';
import type { ReactNode } from 'react';
const handleTrackingAction = (): void => {
  trackEvent({
    category: 'Nya tipsen',
    action: 'change_draw_button_clicked',
    optLabel: 'Powerplay'
  });
};

/**
 * Client container to setup tracking action for open modal button in draw card.
 *
 * @returns OpenModalButton with tracking action for draw card
 */
export default function DrawCardOpenModalButton() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <OpenModalButton queryOnLargeScreen={{
      drawOpen: true
    }} queryOnSmallScreen={{
      modal: "draw"
    }} trackingAction={handleTrackingAction}>Byt omgång</OpenModalButton>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}